module.exports = __webpack_public_path__ + "static/media/logo_paypal.fdd0eaa6.svg";